import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App";
import { I18nProvider } from "./i18n/i18n";
import "./styles/base.css";
import "./styles/site.css";
import "./styles/restaurant.css";
import "./styles/legal.css";
import "./styles/real-estate.css";
import "./styles/hospitality.css";
import "./styles/architecture.css";
import "./styles/construction.css";
import "./styles/dental.css";
import "./styles/electrical.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <I18nProvider><BrowserRouter><App /></BrowserRouter></I18nProvider>
  </StrictMode>,
);
